// Canonical funnel order (matches the legacy navigation):
// dates (/) -> rate (+ services/convention/coupon, same step) -> info -> payment -> summary
export type StepKey = 'dates' | 'rate' | 'info' | 'payment' | 'summary'

export interface StepDef {
  key: StepKey
  path: string // relative to /:locale
}

export const STEPS: StepDef[] = [
  { key: 'dates', path: 'book' },
  { key: 'rate', path: 'rate' },
  { key: 'info', path: 'info' },
  { key: 'payment', path: 'payment' },
  { key: 'summary', path: 'summary' },
]

export function stepIndex(key: StepKey): number {
  return STEPS.findIndex((s) => s.key === key)
}

export function stepPath(locale: string, key: StepKey): string {
  const def = STEPS.find((s) => s.key === key)!
  return `/${locale}${def.path ? '/' + def.path : ''}`
}
